
import { LOGIN_USER_SUCCESS, LOGOUT_USER, UPDATE_USER_DATA, INIT_USER_FROM_COOKIES } from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

export const loginUserSuccess = (response) => {
    return {
        type: LOGIN_USER_SUCCESS,
        payload: response,
    };
};

export const logoutUser = (navigate) => {
    return {
        type: LOGOUT_USER,
        payload: { navigate },
    };
};

export const updateUserData = (user) => {
    return {
        type: UPDATE_USER_DATA,
        payload: user,
    };
};

export const initUserFromCookies = () => {
    const user = getLoggedInUser();
    return {
        type: INIT_USER_FROM_COOKIES,
        payload: user,
    };
};
